import { render, staticRenderFns } from "./quotaMonth.vue?vue&type=template&id=46bb6d02&scoped=true&"
import script from "./quotaMonth.vue?vue&type=script&lang=js&"
export * from "./quotaMonth.vue?vue&type=script&lang=js&"
import style0 from "./quotaMonth.vue?vue&type=style&index=0&id=46bb6d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb6d02",
  null
  
)

export default component.exports